
import { Wrapper } from './style';
import { useState, useEffect } from 'react';

// Components
import Text from 'components/common/Text';
import Carousel from 'components/common/Carousel';
import AboutItem from './AboutItem';
import VideoPlayer from 'components/common/VideoPlayer';
import CallIcon from '@mui/icons-material/Call';
import CustomFAQ from 'components/common/CustomFAQ';

// Libs
import Translation from 'libs/Translation';
import Util from 'libs/Util';

const Demo = ({ faqList }) => {
    const [videoSrc, setVideoSrc] = useState();

    const items = [
        {id: 0, desc: Translation.t('title.demo-about1'), img: '/nextasset/images/demo/doctor.png'},
        {id: 1, desc: Translation.t('title.demo-about2'), img: '/nextasset/images/demo/telemedicine.png'},
        {id: 2, desc: Translation.t('title.demo-about3'), img: '/nextasset/images/demo/direct.png'},
        {id: 3, desc: Translation.t('title.demo-about4'), img: '/nextasset/images/demo/health-insurance.png'},
        {id: 4, desc: Translation.t('title.demo-about5'), img: '/nextasset/images/demo/portal.png'},
        {id: 5, desc: Translation.t('title.demo-about6'), img: '/nextasset/images/demo/work-schedule.png'},
        {id: 6, desc: Translation.t('title.demo-about7'), img: '/nextasset/images/demo/diagnostic-tool.png'},
        {id: 7, desc: Translation.t('title.demo-about8'), img: '/nextasset/images/demo/information.png'},
        {id: 8, desc: Translation.t('title.demo-about9'), img: '/nextasset/images/demo/ordering.png'},
        {id: 9, desc: Translation.t('title.demo-about10'), img: '/nextasset/images/demo/id-card.png'}
    ]

    // Connect to minio
    useEffect(async () => {
        const fileName = 'assets/video.webm';
        Util.connectToMinio('mobile', fileName, setVideoSrc);
    }, []);

    return (
        <Wrapper>
            <div className='column-flex'>
                <Text
                    tag="p"
                    className="main-title"
                >
                    {Translation.t('text.vclinic-doctors-experience')}
                </Text>
                <Text
                    tag="p"
                    className="desc"
                >
                    {Translation.t('title.demo-desc')}
                </Text>
                <VideoPlayer
                    src={videoSrc}
                    customWidth={750}
                    customScreenWidth={800}
                    poster="/nextasset/images/demo/poster.png"
                />
            </div>
            <div className='column-flex'>
                <Text
                    tag="h2"
                    className="about-title"
                >
                    {Translation.t('title.about-demo')}
                </Text>
                <Text
                    tag="h3"
                    className="about-desc"
                >
                    {Translation.t('title.about-demo-desc')}
                </Text>
                <Carousel
                    id="demo"
					items={items}
                    arrow={false}
                    padding={true}
					renderItem={item => <AboutItem {...item} />}
				/>
            </div>

            {faqList?.length ?
                <CustomFAQ faq={faqList} />
            : null }

            <div className='column-flex'>
                <Text
                    tag="p"
                    className="contact-title"
                >
                    {Translation.t('title.demo-contact')}
                </Text>
                <div className='call-info'>
                    <Text
                        tag="p"
                        className="contact-desc"
                    >
                        <a
                            href={`tel: ${Translation.t('text.demo-desc')}`}
                            className="contact-desc"
                        >
                            {Translation.t('text.demo-desc')}
                        </a>
                    </Text>
                    <CallIcon
                        className='icon'
                    />
                </div>
            </div>
        </Wrapper>
    )
}

export default Demo;